module.exports = __webpack_public_path__ + "media/images/logo-60060fcde5444f477b97eebf91e0a6a8.png";